import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";
import { PageLayout } from "@/ui/components/common/PageLayout";

/**
 * 404 頁面組件
 * 當用戶訪問不存在的路徑時顯示
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageLayout title={t("errors.page_not_found")}>
      <div className="flex flex-col items-center justify-center py-12">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-800 dark:text-gray-200">
            404
          </h1>
          <div className="h-2 w-24 bg-blue-600 mx-auto my-4"></div>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4">
            {t("errors.page_not_found")}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            {t("errors.page_not_found_message")}
          </p>
        </div>

        <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-md transition-colors duration-200"
          >
            {t("errors.go_back")}
          </button>
          <Link
            to={ROUTES.HOME}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors duration-200"
          >
            {t("common.back_to_home")}
          </Link>
          <Link
            to={ROUTES.PROFILE}
            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 font-medium rounded-md transition-colors duration-200"
          >
            {t("common.go_to_profile")}
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
